module.exports = __webpack_public_path__ + "img/GH-corporate-top001.af8a69e0.png";